import React from "react";

import { useKarateUi } from "@/hooks/useKarateUi.js";



/** @param {{ compact?: boolean }} props */

export function DemoBadge({ compact = false }) {

  const { demoBadge } = useKarateUi();

  return (

    <span className={`demo-badge-pill${compact ? " demo-badge-pill--compact" : ""}`} data-testid="demo-badge">

      {demoBadge}

    </span>

  );

}



/** @param {{ demo?: boolean, className?: string }} props */

export function DemoFlag({ demo, className = "" }) {

  if (!demo) return null;

  return <DemoBadge compact className={className} />;

}


